import './styles/component.subscribe-form.scss';
import { isNullOrUndef } from '../js/helpers/isNullOrUndef';
import { isNotNullOrUndef } from '../js/helpers/isNotNullOrUndef';
import { Triggers } from '../js/triggers';
import { shopifyGRecaptcha } from '../js/helpers/shopifyGRecaptcha';
import { dlSubscribeErrorEvent } from '../events/subscribe/dl.subscribe.error.event';
import { dlSubscribeSuccessEvent } from '../events/subscribe/dl.subscribe.success.event';
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'onsubmit') {
            const target = mutation.target;
            const newValue = target.getAttribute('onsubmit');
            if (isNotNullOrUndef(newValue) && !newValue.includes('preventDefault')) {
                target.setAttribute('onsubmit', 'event.preventDefault();');
            }
        }
    });
});
class ComponentSubscribeForm extends HTMLElement {
    emailForm = null;
    emailInput = null;
    triggers = new Triggers();
    on = this.triggers.on;
    connectedCallback() {
        this.emailForm = this.querySelector('[data-c-form="email"]');
        this.emailInput = this.querySelector('[data-c-input="email"]');
        if (!isNotNullOrUndef(this.emailForm))
            return;
        observer.observe(this.emailForm, {
            attributes: true
        });
        this.sendEmailForm = this.sendEmailForm.bind(this);
        this.emailForm.addEventListener('submit', event => {
            event.preventDefault();
            void shopifyGRecaptcha(event.currentTarget, 'customer')
                .then(this.sendEmailForm);
        });
        this.initCopyCoupon();
    }
    get loading() {
        return this.hasAttribute('data-loading');
    }
    set loading(v) {
        v
            ? this.setAttribute('data-loading', '')
            : this.removeAttribute('data-loading');
    }
    get success() {
        return this.hasAttribute('data-success');
    }
    set success(v) {
        if (v) {
            if (isNotNullOrUndef(this.emailInput)) {
                this.emailInput.value = '';
            }
            this.loading = false;
            this.error = false;
            this.setAttribute('data-success', '');
            this.triggers.emitEvent('success');
        }
        else {
            this.removeAttribute('data-success');
        }
    }
    get error() {
        return this.hasAttribute('data-error');
    }
    set error(v) {
        if (v) {
            this.loading = false;
            this.success = false;
            this.setAttribute('data-error', '');
        }
        else {
            this.removeAttribute('data-error');
        }
    }
    initCopyCoupon() {
        const codeCopy = this.querySelector('[data-c-success] button');
        const codeInput = this.querySelector('[data-c-success] input');
        if (isNullOrUndef(codeCopy) || isNullOrUndef(codeInput))
            return;
        let timeout = 0;
        codeCopy.addEventListener('click', () => {
            void navigator.clipboard.writeText(codeInput.value).then(() => {
                codeCopy.textContent = 'COPIED, USE IT AT CHECKOUT';
            });
            window.clearTimeout(timeout);
            timeout = window.setTimeout(() => {
                this.triggers.emitEvent('codeCopyClose');
                this.success = false;
            }, 2000);
        });
    }
    async sendEmailForm() {
        this.triggers.emitEvent('send');
        this.loading = true;
        const result = await this.sendEmail();
        if (isNotNullOrUndef(this.emailInput) && isNotNullOrUndef(this.emailForm)) {
            if (result) {
                dlSubscribeSuccessEvent(this.emailForm.id, this.emailInput.value);
                window.Cookies.set('customerAM', 'true', {
                    expires: 36500,
                    sameSite: 'lax'
                });
                window.Cookies.set('customerEmail', this.emailInput.value, {
                    expires: 36500,
                    sameSite: 'lax'
                });
            }
            else {
                dlSubscribeErrorEvent(this.emailForm.id, this.emailInput.value);
            }
        }
        if (result) {
            this.success = true;
            document.querySelector('welcome-popup-component')?.closeReminder();
        }
        else {
            this.error = true;
        }
    }
    async sendEmail() {
        if (isNullOrUndef(this.emailForm))
            return false;
        try {
            const response = await fetch(this.emailForm.action, {
                method: 'POST',
                body: new FormData(this.emailForm)
            });
            if (response.ok) {
                const html = await response.text();
                if (isNotNullOrUndef(html)) {
                    const url = (html.match(/"pageurl":"(.*?)"/) ?? [])[1];
                    if (url.includes('?customer_posted=true')) {
                        return true;
                    }
                }
            }
            return false;
        }
        catch (e) {
            console.log(e);
            return false;
        }
    }
}
customElements.define('subscribe-form-component', ComponentSubscribeForm);
